import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Card from '../../../components/Card/Card';
import Button from '../../../components/Button/Button';
import { IconPlus } from '../../../assets/icon';
import ButtonTypes from '../../../constants/buttonTypes';
import AddCarsModal from './AddCarsModal';
import SelectedCarList from '../../../components/SelectedCarList/SelectedCarList';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';
const buttonClassName = 'px-[8px] py-[8px] font-normal text-[12px]';

const ArticlesCars = ({ values, onSelect }) => {
  const [addCarModalVisible, setAddCarVisible] = useState(false);

  return (
    <Card
      headerTitle="For Cars:"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
    >
      <div>
        <SelectedCarList cars={values} />
      </div>
      <br />
      <Button
        type={ButtonTypes.LIGHT_PRIMARY}
        icon={<IconPlus />}
        text="Cars"
        containerStyle={buttonClassName}
        onClick={() => setAddCarVisible(true)}
      />
      <AddCarsModal
        visible={addCarModalVisible}
        toggleVisible={() => setAddCarVisible(false)}
        preselect={values}
        onSelect={onSelect}
      />
    </Card>
  );
};

ArticlesCars.propTypes = {
  values: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func,
};

ArticlesCars.defaultProps = {
  onSelect: () => {},
  values: null
};

export default ArticlesCars;
